import { render, staticRenderFns } from "./ProductTilePreloader.vue?vue&type=template&id=2df160fc&scoped=true&"
import script from "./ProductTilePreloader.vue?vue&type=script&lang=ts&"
export * from "./ProductTilePreloader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTilePreloader.vue?vue&type=style&index=0&id=2df160fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df160fc",
  null
  
)

export default component.exports